import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

const FAQPage = () => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  
  const faqs = [
  {
    id: 1,
    question: "What kind of products does Vantara Gandhigram offer?",
    answer:
      "Vantara Gandhigram offers a range of eco-friendly and handcrafted products made in Wayanad, including natural food items, herbal wellness products, handmade soaps, and sustainable lifestyle goods.",
  },
  {
    id: 2,
    question: "Are all your products locally made in Wayanad?",
    answer:
      "Yes. Every Vantara Gandhigram product is carefully crafted in Wayanad using locally sourced ingredients and traditional methods that support local communities and preserve the environment.",
  },
  {
    id: 3,
    question: "Are your products organic and chemical-free?",
    answer:
      "Most of our products are made using natural, chemical-free ingredients. We prioritize organic materials wherever possible and ensure all items are safe for you and the environment.",
  },
  {
    id: 4,
    question: "How can I place an order?",
    answer:
      "You can order directly through our website. Simply browse the products, add them to your cart, and proceed to checkout. We currently deliver across India.",
  },
  {
    id: 5,
    question: "What payment methods do you accept?",
    answer:
      "We accept major debit and credit cards, UPI, net banking, and select digital wallets. Cash on Delivery (COD) is available for eligible locations.",
  },
  {
    id: 6,
    question: "How long will it take to receive my order?",
    answer:
      "Orders are usually delivered within 5–7 business days across India. Rural or remote areas may take a little longer depending on courier availability.",
  },
  {
    id: 7,
    question: "Do you ship outside India?",
    answer:
      "Currently, we only deliver within India. International shipping options will be available soon.",
  },
  {
    id: 8,
    question: "Can I return or exchange a product?",
    answer:
      "If you receive a damaged or incorrect item, please contact us within 3 days of delivery. Since our products are handmade and perishable, we do not accept returns for used or opened items.",
  },
  {
    id: 9,
    question: "How do I know my product is genuine?",
    answer:
      "All Vantara Gandhigram products come directly from our production unit in Wayanad. Each item is quality checked and packaged with a unique authenticity tag before dispatch.",
  },
  {
    id: 10,
    question: "Who can I contact for support or bulk orders?",
    answer:
      "You can reach our customer support team via the 'Contact Us' page on our website or email us at support@vantara.in for any queries or bulk purchase requests.",
  },
];


  return (
    <>
      <div className="py-5 bg-white">
        <Container>
          <Row>
            {/* Left Column - FAQs */}
            <Col md={8}>
              <h2 className=" mb-4">How To Buy</h2>

              {faqs.map((faq) => (
                <div key={faq.id} className="mb-3 border-bottom">
                  <div
                    className="d-flex justify-content-between align-items-center p-3 cursor-pointer"
                    onClick={() => toggleItem(faq.id)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && toggleItem(faq.id)}
                  >
                    <h5 className="mb-0 text-dark fw-bold">{faq.question}</h5>
                    <span className="fs-4">
                      {openItems.has(faq.id) ? "-" : "+"}
                    </span>
                  </div>
                  {openItems.has(faq.id) && (
                    <div className="p-3 bg-white border-top">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          color: "#313131FF",
                        }}
                      >{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
              {/* 
            <h3 className="fw-bold mt-5 mb-4">Exchanges & Returns</h3>
            <p className="text-muted small mb-0">
              Learn how to return or exchange your items.
            </p> */}
            </Col>

            {/* Right Column - Contact Form */}

          </Row>
        </Container>

      </div>
      <hr />
    </>
  );
};

export default FAQPage;